/* ============================================
   ANVIL NUTRITION — Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  // --- Announcement Bar Dismiss ---
  const announcementBar = document.querySelector('[data-announcement]');
  const announcementClose = document.querySelector('[data-announcement-close]');
  if (announcementBar && announcementClose) {
    if (sessionStorage.getItem('anvil_announcement_dismissed') === '1') {
      announcementBar.classList.add('is-hidden');
    }
    announcementClose.addEventListener('click', () => {
      announcementBar.classList.add('is-hidden');
      try { sessionStorage.setItem('anvil_announcement_dismissed', '1'); } catch (e) {}
    });
  }

  // --- Sticky Header Scroll State ---
  const siteHeader = document.querySelector('[data-header]');
  if (siteHeader) {
    const onScroll = () => {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // --- Mobile Menu Toggle ---
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.getElementById('mobile-nav');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // --- Header Search Toggle ---
  const searchToggle = document.querySelector('[data-search-toggle]');
  const headerSearch = document.getElementById('header-search');

  if (searchToggle && headerSearch) {
    searchToggle.addEventListener('click', () => {
      const isOpen = !headerSearch.toggleAttribute('hidden');
      searchToggle.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) {
        const input = headerSearch.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  // --- Cart Drawer ---
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawerBody = document.getElementById('cart-drawer-body');
  const cartDrawerFooter = document.getElementById('cart-drawer-footer');
  const cartDrawerTotal = document.getElementById('cart-drawer-total');

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function renderCartDrawer() {
    if (!cartDrawerBody) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (!cart.items || cart.items.length === 0) {
        cartDrawerBody.innerHTML = '<p class="cart-drawer__empty">Your cart is currently empty.</p>';
        if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
        return;
      }

      cartDrawerBody.innerHTML = cart.items.map((item) => {
        const key = escapeHtml(item.key);
        const url = escapeHtml(item.url);
        const img = item.image
          ? '<img class="cart-drawer__item-image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" width="64" height="64" loading="lazy">'
          : '<div class="cart-drawer__item-image cart-drawer__item-image--empty"></div>';
        const variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
        return '' +
          '<div class="cart-drawer__item">' +
            img +
            '<div class="cart-drawer__item-details">' +
              '<a class="cart-drawer__item-title" href="' + url + '">' + escapeHtml(item.product_title) + '</a>' +
              variant +
              '<div class="cart-drawer__item-controls">' +
                '<div class="cart-drawer__qty">' +
                  '<button type="button" class="cart-drawer__qty-btn" data-drawer-qty-minus="' + key + '" aria-label="Decrease quantity">&minus;</button>' +
                  '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                  '<button type="button" class="cart-drawer__qty-btn" data-drawer-qty-plus="' + key + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="cart-drawer__item-remove" data-drawer-remove="' + key + '">Remove</button>' +
              '</div>' +
            '</div>' +
            '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');

      if (cartDrawerTotal) cartDrawerTotal.textContent = formatMoney(cart.total_price);
      if (cartDrawerFooter) cartDrawerFooter.style.display = '';
    } catch {
      // Leave existing drawer contents on failure
    }
  }

  async function changeCartLine(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      await renderCartDrawer();
      updateCartCount();
    } catch {
      // Silently fail
    }
  }

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      renderCartDrawer();
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', openCartDrawer);
  }

  document.querySelectorAll('[data-cart-close]').forEach((btn) => {
    btn.addEventListener('click', closeCartDrawer);
  });

  if (cartDrawerBody) {
    cartDrawerBody.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-drawer-remove]');
      const minusBtn = e.target.closest('[data-drawer-qty-minus]');
      const plusBtn = e.target.closest('[data-drawer-qty-plus]');
      if (removeBtn) {
        changeCartLine(removeBtn.dataset.drawerRemove, 0);
      } else if (minusBtn) {
        const span = minusBtn.parentElement.querySelector('.cart-drawer__qty-value');
        const q = Math.max(0, (parseInt(span.textContent, 10) || 1) - 1);
        changeCartLine(minusBtn.dataset.drawerQtyMinus, q);
      } else if (plusBtn) {
        const span = plusBtn.parentElement.querySelector('.cart-drawer__qty-value');
        const q = (parseInt(span.textContent, 10) || 1) + 1;
        changeCartLine(plusBtn.dataset.drawerQtyPlus, q);
      }
    });
  }

  // --- FAQ Accordion ---
  document.querySelectorAll('[data-faq-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.faq-item.is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // --- Product Page: Quantity Controls ---
  const qtyMinus = document.querySelector('[data-qty-minus]');
  const qtyPlus = document.querySelector('[data-qty-plus]');
  const qtyInput = document.getElementById('product-qty');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });

    qtyPlus.addEventListener('click', () => {
      const val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // --- Product Page: Image Thumbnails ---
  document.querySelectorAll('[data-thumb-btn]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const url = thumb.dataset.imageUrl;
      const mainImg = document.getElementById('product-image-main');
      if (mainImg && url) {
        mainImg.src = url;
      }

      document.querySelectorAll('[data-thumb-btn]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // --- Product Page: Tabs ---
  document.querySelectorAll('[data-tab]').forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;

      document.querySelectorAll('.product-tabs__tab').forEach((t) => t.classList.remove('is-active'));
      document.querySelectorAll('.product-tabs__panel').forEach((p) => p.classList.remove('is-active'));

      tab.classList.add('is-active');
      const panel = document.querySelector(`[data-panel="${target}"]`);
      if (panel) panel.classList.add('is-active');
    });
  });

  // --- Product Page: Variant Selection ---
  document.querySelectorAll('[data-variant-option]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const optionIndex = btn.dataset.optionIndex;
      const value = btn.dataset.variantOption;

      // Update active state in this option group
      btn.closest('.product-form__variant-options')
        .querySelectorAll('.product-form__variant-btn')
        .forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      // Find matching variant
      const select = document.getElementById('variant-select');
      if (select) {
        const options = Array.from(select.options);
        const selected = options.find((opt) => opt.text.includes(value));
        if (selected) {
          select.value = selected.value;
          // Update price display
          const priceEl = document.querySelector('.product-page__price');
          if (priceEl && selected.dataset.price) {
            priceEl.innerHTML = selected.dataset.price;
          }
        }
      }
    });
  });

  // --- Add to Cart (AJAX) ---
  const productForm = document.getElementById('product-form');

  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = productForm.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      try {
        const formData = new FormData(productForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (res.ok) {
          submitBtn.textContent = 'Added!';
          updateCartCount();
          openCartDrawer();
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        } else {
          submitBtn.textContent = 'Error';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        }
      } catch {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    });
  }

  // --- Update Cart Count ---
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.getElementById('cart-count');
      if (countEl) {
        if (cart.item_count > 0) {
          countEl.textContent = cart.item_count;
          countEl.style.display = 'flex';
        } else {
          countEl.style.display = 'none';
        }
      }
    } catch {
      // Silently fail
    }
  }

  // Initial cart count
  updateCartCount();

  // --- Cart Page: Remove Items ---
  document.querySelectorAll('[data-remove-item]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.removeItem;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        window.location.reload();
      } catch {
        // Silently fail
      }
    });
  });

  // --- Cart Page: Quantity Buttons ---
  document.querySelectorAll('[data-cart-qty-minus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.cartQtyMinus;
      const input = document.querySelector(`[data-cart-qty-input="${key}"]`);
      if (input) {
        const val = parseInt(input.value) || 1;
        if (val > 1) {
          input.value = val - 1;
          updateCartItem(key, val - 1);
        }
      }
    });
  });

  document.querySelectorAll('[data-cart-qty-plus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.cartQtyPlus;
      const input = document.querySelector(`[data-cart-qty-input="${key}"]`);
      if (input) {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
        updateCartItem(key, val + 1);
      }
    });
  });

  async function updateCartItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      window.location.reload();
    } catch {
      // Silently fail
    }
  }

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
